import { ParcelStatus } from "@/enums";

// statusses to filter unpaid parcels
export const unpaidParcelStatuses = [
  ParcelStatus.COMMON_STATUS_SHIPPED_FROM_FCOUNTRY,
  ParcelStatus.COMMON_STATUS_RECEIVED_OUTSTOCK,
  ParcelStatus.COMMON_STATUS_READY_FOR_PICKUP,
];
